export default __webpack_public_path__ + "assets/ico_back_white-d25e095c.svg";